export const matchingConditions = ["match", "not_match", "greater", "smaller", "starts_with"] as const;
export type MatchingConditions = typeof matchingConditions[number];
